import React from "react";
import client from "../../assets/img/client-1.jpg";
import client2 from "../../assets/img/client-2.jpg";
import client3 from "../../assets/img/client-3.jpg";
import client5 from "../../assets/img/client-5.jpg";
import client6 from "../../assets/img/client-6.jpg";
import client7 from "../../assets/img/client-7.jpg";
import client8 from "../../assets/img/client-8.jpg";
import client9 from "../../assets/img/client-9.jpg";
import professionalism from "../../assets/img/icon_professionalism.jpg";
import icon_love from "../../assets/img/icon_love_for_work.jpg";
import icon_enthusiasm from "../../assets/img/icon_enthusiasm.jpg";
import icon_exeeding from "../../assets/img/icon_exeeding_limits.jpg";
import like_at from "../../assets/img/like-at-game-district.png";
import servicesiconsbg from "../../assets/img/servicesiconsbg.jpg";
import iconOne from "../../assets/img/icon-1.jpg";
import iconSix from "../../assets/img/icon-6.jpg";
import iconTen from "../../assets/img/icon-10.jpg";
import iconTwo from "../../assets/img/icon-2.jpg";
import iconSeven from "../../assets/img/icon-7.jpg";
import iconElven from "../../assets/img/icon-11.jpg";
import iconThirteen from "../../assets/img/icon-13.png";
import iconThree from "../../assets/img/icon-3.jpg";
import iconEight from "../../assets/img/icon-8.jpg";
import iconFive from "../../assets/img/icon-5.jpg";
import iconNine from "../../assets/img/icon-9.jpg";
import iconTwvel from "../../assets/img/icon-12.jpg";
import iconFoutheen from "../../assets/img/icon-14.jpg";
import gameDistrict from "../../assets/img/game-district.jpg";
import dots from "../../assets/img/dots.jpg";
import globalOne from "../../assets/img/global_icon_1.jpg";
import globalTwo from "../../assets/img/global_icon_2.jpg";
import globalThree from "../../assets/img/global_icon_3.jpg";
import globalFour from "../../assets/img/global_icon_4.jpg";
import globalFive from "../../assets/img/global_icon_5.jpg";
import globalSix from "../../assets/img/global_icon_6.jpg";
import galleryOne from "../../assets/img/gallery-1.jpg";
import galleryTwo from "../../assets/img/gallery-2.jpg";
import galleryThree from "../../assets/img/gallery-3.jpg";
import galleryFour from "../../assets/img/gallery-4.jpg";
import galleryFive from "../../assets/img/gallery-5.jpg";
import gallerySix from "../../assets/img/gallery-6.jpg";
import gallerySeven from "../../assets/img/gallery-7.jpg";
import galleryEight from "../../assets/img/gallery-8.jpg";
import galleryNine from "../../assets/img/gallery-9.jpg";
import galleryTen from "../../assets/img/gallery-10.jpg";
import galleryElven from "../../assets/img/gallery-11.jpg";
import galleryTwvel from "../../assets/img/gallery-12.jpg";
import galleryThirteen from "../../assets/img/gallery-13.jpg";
import { NavLink } from "react-router-dom";
function AboutUs() {
  return (
    <>
      <div className="fullpage">
        <div className="about_section_1">
          <div className="container">
            <div className="about_section_inner">
              <div className="row">
                <div
                  className="wow fadeInDown col-lg-12"
                  style={{
                    visibility: "visible",
                    animationName: " fadeInDown",
                  }}
                >
                  <h1>
                    We Give Wings To
                    <br />
                    Your Dreams
                  </h1>
                  <p>
                    Fun Pro Games longs for fresh &amp; young minds who can
                    mould their approaches with the changing challenges of the
                    digital industry.{" "}
                  </p>
                </div>
              </div>
              <div className="clr"></div>
              <div className="row">
                <div className="col-lg-3"></div>
                <div className="col-lg-2">
                  <div
                    className="wow slideInLeft dreams"
                    style={{
                      visibility: "visible",
                      animationName: "slideInLeft",
                    }}
                  >
                    <h5>
                      6<span>+</span>
                    </h5>
                    <p>Years since inception</p>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div
                    className="wow bounceInUp  dreams"
                    style={{
                      visibility: "visible",
                      animationName: "bounceInUp",
                    }}
                  >
                    <h5>
                      350<span>+</span>
                    </h5>
                    <p>Strong Team</p>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div
                    className="wow slideInRight dreams"
                    style={{
                      visibility: "visible",
                      animationName: "slideInRight;",
                    }}
                  >
                    <h5>
                      56K<span>+</span>
                    </h5>
                    <p>Projects Delivered</p>
                  </div>
                </div>
                <div className="col-lg-3"></div>
              </div>
              <div className="clr"></div>
            </div>
            <div className="clr"></div>
          </div>
        </div>
        <div className="about_section_3">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="wow slideInDown whats_deives"
                  style={{
                    visibility: "visible",
                    animationName: "slideInDown;",
                  }}
                >
                  <div className="whats_deives_title">
                    <h1>What Drives Us?</h1>
                    <h1 className="white">What Drives Us?</h1>
                  </div>
                  <p>
                    Fun Pro Games longs for fresh &amp; young minds who can
                    mould their
                    <br />
                    approaches with the changing.
                  </p>
                </div>
              </div>
              <div className="clr"></div>
              <div className="col-lg-12">
                <div className="whatsdeives_area">
                  <div
                    className="wow slideInLeft whatsdeives_1"
                    style={{
                      visibility: "visible",
                      animationName: "slideInLeft;",
                    }}
                  >
                    <div className="icon">
                      <img alt="" src={professionalism} />
                    </div>
                    <div className="whatsdeives_info">
                      <h3>01</h3>
                      <h6>Professionalism</h6>
                      <p>
                        Fun Pro Games longs for fresh &amp; young minds who can
                        mould their approaches with the changing challenges of
                        the digital industry.
                      </p>
                    </div>
                  </div>
                  <div
                    className="wow slideInRight whatsdeives_1"
                    style={{
                      visibility: "visible",
                      animationName: "slideInRight;",
                    }}
                  >
                    <div className="icon">
                      <img alt="" src={icon_love} />
                    </div>
                    <div className="whatsdeives_info">
                      <h3>02</h3>
                      <h6>Love For Work</h6>
                      <p>
                        Fun Pro Games longs for fresh &amp; young minds who can
                        mould their approaches with the changing challenges of
                        the digital industry.
                      </p>
                    </div>
                  </div>
                  <div className="clr"></div>
                  <div
                    className="wow slideInLeft whatsdeives_3"
                    style={{
                      visibility: "visible",
                      animationName: "slideInLeft;",
                    }}
                  >
                    <div className="icon">
                      <img alt="" src={icon_enthusiasm} />
                    </div>
                    <div className="whatsdeives_info">
                      <h3>03</h3>
                      <h6>Enthusiasm</h6>
                      <p>
                        Fun Pro Games longs for fresh &amp; young minds who can
                        mould their approaches with the changing challenges of
                        the digital industry.
                      </p>
                    </div>
                  </div>
                  <div
                    className="wow slideInRight whatsdeives_3"
                    style={{
                      visibility: "visible",
                      animationName: "slideInRight;",
                    }}
                  >
                    <div className="icon">
                      <img alt="" src={icon_exeeding} />
                    </div>
                    <div className="whatsdeives_info">
                      <h3>04</h3>
                      <h6>Exceeding Limits</h6>
                      <p>
                        Fun Pro Games longs for fresh &amp; young minds who can
                        mould their approaches with the changing challenges of
                        the digital industry.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="clr"></div>
              </div>
            </div>
            <div className="clr"></div>
          </div>
        </div>
        <div className="about_section_4">
          <div className="container">
            <div className="row">
              <div
                className="wow slideInDown col-lg-12"
                style={{ visibility: "visible", animationName: "slideInDown;" }}
              >
                <img
                  className="like_title"
                  alt="like-at-game-distric"
                  src={like_at}
                />
                <p>
                  Fun Pro Games longs for fresh &amp; young minds who can mould
                  their approaches with <br />
                  the changing challenges of the digital industry. A growing
                  mind is one of the cherished sights
                  <br />
                  for us as it’s a proof of one’s growth &amp; success in the
                  right direction.
                </p>
                <div className="clr"></div>
              </div>
            </div>
            <div className="clr"></div>
            <div className="row">
              <div className="col-lg-12">
                <div className="likes_gamedistrict">
                  <img className="icon_full" alt="" src={servicesiconsbg} />
                  <div className="like_icons_raw1">
                    <img
                      className="wow rollIn icon_1"
                      alt=""
                      src={iconOne}
                      style={{ visibility: "visible", animationName: "rollIn" }}
                    />
                    <img
                      className="wow bounceInDown icon_2"
                      alt=""
                      src={iconSix}
                      style={{
                        visibility: "visible",
                        animationName: "bounceInDown",
                      }}
                    />
                    <img
                      className="wow rollOut icon_3"
                      alt=""
                      src={iconTen}
                      style={{
                        visibility: "visible",
                        animationName: "rollOut;",
                      }}
                    />
                  </div>
                  <div className="like_icons_raw1">
                    <img
                      className="wow slideInLeft icon_4"
                      alt=""
                      src={iconTwo}
                      style={{
                        visibility: "visible",
                        animationName: "slideInLeft",
                      }}
                    />
                    <img
                      className="wow bounceInDown icon_5"
                      alt=""
                      src={iconSeven}
                      style={{
                        visibility: "visible",
                        animationName: "bounceInDown",
                      }}
                    />
                    <img
                      className="wow bounceInDown icon_7"
                      alt=""
                      src={iconElven}
                      style={{
                        visibility: "visible",
                        animationName: "bounceInDown",
                      }}
                    />
                    <img className="icon_8" alt="" src={iconThirteen} />
                  </div>
                  <div className="like_icons_raw1">
                    <img className="icon_9" alt="" src={iconThree} />
                    <img
                      className="wow pulse icon_6"
                      alt=""
                      src={iconEight}
                      data-wow-iteration="3"
                      style={{
                        visibility: "visible",
                        animationIterationCount: "3",
                        animationName: "pulse",
                      }}
                    />
                  </div>
                  <div className="like_icons_raw1">
                    <img
                      className="wow slideInLeft icon_10"
                      alt=""
                      src={iconFive}
                      style={{
                        visibility: "visible",
                        animationName: "slideInLeft",
                      }}
                    />
                    <img
                      className="wow bounceInDown icon_11"
                      alt=""
                      src={iconNine}
                      style={{
                        visibility: " visible",
                        animationName: "bounceInDown",
                      }}
                    />
                    <img
                      className="wow slideInRight icon_12"
                      alt=""
                      src={iconTwvel}
                      style={{
                        visibility: "visible",
                        animationName: "slideInRight",
                      }}
                    />
                  </div>
                  <div className="like_icons_raw1">
                    <img
                      className="wow bounceInRight icon_13"
                      alt=""
                      src={iconFoutheen}
                      style={{
                        visibility: "visible",
                        animationName: "bounceInRight",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="clr"></div>
          </div>
        </div>
        <div className="about_section_5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h1>
                  Ready to start your project<span>?</span>
                  <NavLink to="/about-us" className="start">
                    Let’s Start
                  </NavLink>
                </h1>
              </div>
            </div>
            <div className="clr"></div>
          </div>
        </div>
        <div className="about_section_6">
          <div className="container">
            <div className="row">
              <div
                className="wow slideInDown col-lg-12"
                style={{ visibility: "visible", animationName: " slideInDown" }}
              >
                <h1>Our Clients</h1>
                <p>
                  Fun Pro Games longs for fresh &amp; young minds who can mould
                  their <br />
                  approaches with the changing.
                </p>
              </div>
              <div className="col-lg-12">
                <div className="our_clients">
                  <img alt="" src={client} />
                  <img alt="" src={client2} />
                  <img alt="" src={client3} />
                  <img alt="" src={client5} />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="our_clients">
                  <img alt="" src={client6} />
                  <img alt="" src={client7} />
                  <img alt="" src={client8} />
                  <img alt="" src={client9} />
                </div>
              </div>
            </div>
            <div className="clr"></div>
          </div>
        </div>
        <div className="about_section_7">
          <div className="container">
            <div className="row">
              <div
                className="wow slideInDown col-lg-12"
                style={{ visibility: " visible", animationName: "slideInDown" }}
              >
                <img alt="" src={gameDistrict} />
                <p>
                  Dubai<span>-</span>SanFrancisco<span>-</span>Manama
                  <span>-</span>Lahore
                </p>
              </div>
              <div className="dots">
                <img alt="" src={dots} />
              </div>
              <div className="col-lg-12">
                <div className="global_icon">
                  <img alt="" src={globalOne} />
                  <img alt="" src={globalTwo} />
                  <img alt="" src={globalThree} />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="global_icon">
                  <img alt="" src={globalFour} />
                  <img alt="" src={globalFive} />
                  <img alt="" src={globalSix} />
                </div>
              </div>
            </div>
            <div className="clr"></div>
          </div>
        </div>
        {/* <div className="about_section_8">
          <div className="gallery_raw">
            <div className="owl-carousel owl-theme owl-loaded owl-drag">
              <div className="owl-stage-outer">
                <div
                  className="owl-stage"
                  style={{
                    transform: "translate3d(-1381px, 0px, 0px)",
                    transition: "0.25s",
                    width: "2764px",
                  }}
                >
                  <div className="owl-item" style={{ width: "230.333px" }}>
                    <div className="item">
                      <img alt="" src={galleryOne} />
                    </div>
                  </div>
                  <div className="owl-item" style={{ width: "230.333px" }}>
                    <div className="item">
                      <img alt="" src={galleryTwo} />
                    </div>
                  </div>
                  <div className="owl-item" style={{ width: " 230.333px" }}>
                    <div className="item">
                      <img alt="" src={galleryThree} />
                    </div>
                  </div>
                  <div className="owl-item" style={{ width: "230.333px" }}>
                    <div className="item">
                      <img alt="" src={galleryFour} />
                    </div>
                  </div>
                  <div className="owl-item" style={{ width: " 230.333px" }}>
                    <div className="item">
                      <img alt="" src={galleryFive} />
                    </div>
                  </div>
                  <div className="owl-item" style={{ width: "230.333px" }}>
                    <div className="item">
                      <img alt="" src={gallerySix} />
                    </div>
                  </div>
                  <div
                    className="owl-item active"
                    style={{ width: "230.333px;" }}
                  >
                    <div className="item">
                      <img alt="" src={galleryOne} />
                    </div>
                  </div>
                  <div
                    className="owl-item active"
                    style={{ width: "230.333px;" }}
                  >
                    <div className="item">
                      <img alt="" src={galleryTwo} />
                    </div>
                  </div>
                  <div
                    className="owl-item active"
                    style={{ width: "230.333px" }}
                  >
                    <div className="item">
                      <img alt="" src={galleryThree} />
                    </div>
                  </div>
                  <div
                    className="owl-item active"
                    style={{ width: "230.333px;" }}
                  >
                    <div className="item">
                      <img alt="" src={galleryFour} />
                    </div>
                  </div>
                  <div
                    className="owl-item active"
                    style={{ width: "230.333px;" }}
                  >
                    <div className="item">
                      <img alt="" src={galleryFive} />
                    </div>
                  </div>
                  <div
                    className="owl-item active"
                    style={{ width: " 230.333px;" }}
                  >
                    <div className="item">
                      <img alt="" src={gallerySix} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="owl-nav disabled">
                <button type="button" role="presentation" className="owl-prev">
                  <span aria-label="Previous">‹</span>
                </button>
                <button type="button" role="presentation" className="owl-next">
                  <span aria-label="Next">›</span>
                </button>
              </div>
              <div className="owl-dots disabled"></div>
            </div>
            <div className="clr"></div>
          </div>
          <div className="gallery_raw2">
            <div className="owl-carousel owl-theme owl-loaded owl-drag">
              <div className="owl-stage-outer">
                <div
                  className="owl-stage"
                  style={{
                    transform: "translate3d(-1680px, 0px, 0px)",
                    transition: "0.25s",
                    width: "3360px",
                  }}
                >
                  <div className="owl-item" style={{ width: "240px" }}>
                    <div className="item">
                      <img alt="" src={gallerySeven} />
                    </div>
                  </div>
                  <div className="owl-item" style={{ width: "240px" }}>
                    <div className="item">
                      <img alt="" src={galleryEight} />
                    </div>
                  </div>
                  <div className="owl-item" style={{ width: "240px" }}>
                    <div className="item">
                      <img alt="" src={galleryNine} />
                    </div>
                  </div>
                  <div className="owl-item" style={{ width: "240px" }}>
                    <div className="item">
                      <img alt="" src={galleryTen} />
                    </div>
                  </div>
                  <div className="owl-item" style={{ width: "240px" }}>
                    <div className="item">
                      <img alt="" src={galleryElven} />
                    </div>
                  </div>
                  <div className="owl-item" style={{ width: " 240px" }}>
                    <div className="item">
                      <img alt="" src={galleryTwvel} />
                    </div>
                  </div>
                  <div className="owl-item" style={{ width: "240px" }}>
                    <div className="item">
                      <img alt="" src={galleryThirteen} />
                    </div>
                  </div>
                  <div className="owl-item active" style={{ width: "240px" }} />
                  <div className="item">
                    <img alt="" src={gallerySeven} />
                  </div>
                </div>
                <div className="owl-item active" style={{ width: "240px" }}>
                  <div className="item">
                    <img alt="" src={galleryEight} />
                  </div>
                </div>
                <div className="owl-item active" style={{ width: "240px;" }}>
                  <div className="item">
                    <img alt="" src={galleryNine} />
                  </div>
                </div>
                <div className="owl-item active" style={{ width: "240px;" }}>
                  <div className="item">
                    <img alt="" src={galleryTen} />
                  </div>
                </div>
                <div className="owl-item active" style={{ width: "240px" }}>
                  <div className="item">
                    <img alt="" src={galleryElven} />
                  </div>
                </div>
                <div className="owl-item active" style={{ width: "240px;" }}>
                  <div className="item">
                    <img alt="" src={galleryTwvel} />
                  </div>
                </div>
                <div className="owl-item" style={{ width: "240px;" }}>
                  <div className="item">
                    <img alt="" src={galleryOne} iconThirteen />
                  </div>
                </div>
              </div>
            </div>
            <div className="owl-nav disabled">
              <button type="button" role="presentation" className="owl-prev">
                <span aria-label="Previous">‹</span>
              </button>
              <button type="button" role="presentation" className="owl-next">
                <span aria-label="Next">›</span>
              </button>
            </div>
            <div className="owl-dots disabled"></div>
          </div>
          <div className="clr"></div>
        </div> */}
      </div>
      <div className="clr"></div>
    </>
  );
}

export default AboutUs;
